export interface IChangeLog {
  version: string;
  date: Date;
  scopes?: ChangeLogScope[];
  component: new () => any;
}

export enum ChangeLogScope {
  master = 'master',
}
